module.exports = __webpack_public_path__ + "media/images/m_brabec-5c08cfcc.jpg";